<script setup lang="ts">
    import { inject } from "vue";
    import type { Cta } from "@/helpers/builder-init/index.ts";
    import { getCtaLink } from "@/helpers/interfaces/Cta";
    import RothcoCta from "@/components/RothcoCta.vue";
    import { Link } from "@inertiajs/vue3";
    import RedArrows from "@icons/red-arrows.svg";
    interface Caption {
        text: string;
        featuredPrice: number;
    }
    interface FeaturedItem {
        title: string;
        captions: Caption[];
        badge: string;
        image: string;
        cta: Pick<Cta, "link" | "url" | "aria_label">;
        alt: string;
    }
    let props = defineProps({
        title: {
            type: String,
            required: true
        },
        featuredItems: {
            type: Array as PropType<FeaturedItem[]>,
            required: true
        }
    });

    let closeMobileMenu = inject("closeMobileMenu");
</script>
<template>
    <div>
        <div class="mobile-hidden">
            <p class="headline-m" v-if="title">{{ title }}</p>
            <ul class="nav-level-3-featured-content">
                <li
                    class="featured-content-item"
                    v-for="(item, index) of featuredItems"
                    :key="index"
                >
                    <img
                        class="featured-content-img"
                        :src="item.image"
                        :alt="item.alt"
                    />
                    <p class="featured-content-badge" v-if="item.badge">
                        {{ item.badge }}
                    </p>
                    <div class="featured-content-info">
                        <p class="headline-s" v-if="item.title">
                            {{ item.title }}
                        </p>
                        <p
                            class="paragraph-caption"
                            v-for="(caption, index) of item.captions"
                            :key="index"
                        >
                            {{ caption.text ? caption.text : "from " }}
                            <b
                                v-if="caption.featuredPrice > 0"
                                class="featured-item-price"
                                >${{ caption.featuredPrice }}</b
                            >
                        </p>
                        <RothcoCta
                        ctaType="link"
                        v-bind="getCtaLink(item.cta)"
                        :aria-label="item.cta.aria_label"
                        class="menu-cta-link"
                        >{{
                            item.cta.label
                        }}</RothcoCta>
                    </div>
                </li>
            </ul>
        </div>
        <div class="desktop-hidden">
            <div
                v-for="(item, index) of featuredItems"
                :key="index"
                class="mobile_menu-submenu_product_type_one"
            >
                <Link
                    as="img"
                    v-bind="getCtaLink(item.cta)"
                    :onStart="() => closeMobileMenu()"
                    :src="item.image"
                    :alt="item.alt"
                    class="mobile_menu-submenu_product_type_one"
                />
                <p class="title-s">{{ item.title }}</p>
                <p
                    class="paragraph-caption"
                    v-for="(caption, index) of item.campaign"
                    :key="index"
                >
                    {{ caption.text ? caption.text : "from " }}
                    <span
                        v-if="caption.featuredPrice > 0"
                        class="mobile_menu-submenu_product_type_one-price"
                    >
                        ${{ caption.featuredPrice }}
                    </span>
                </p>
                <div
                    class="mobile_menu-submenu_product_type_one-link_container"
                >
                    <RothcoCta
                        ctaType="link"
                        v-bind="getCtaLink(item.cta)"
                        :aria-label="item.cta.aria_label"
                        :onStart="() => closeMobileMenu()"
                        class="mobile_menu-submenu_product_type_one-link"
                        >{{ item.cta.label }}</RothcoCta
                    >
                    <RedArrows src="@icons/red-arrows.svg" alt="red arrow" />
                </div>
            </div>
        </div>
    </div>
</template>
